import Alerts from "../util/Alerts";
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from "reactstrap";
import React, { useEffect, useRef, useState } from "react";
import ReactTable from "react-table";
import { Activo } from "../coms/BlkGenerales";
import { useSelector } from "react-redux";
import axios from "axios";
import { routes } from "../gen/General";
import { filterCaseInsensitive } from "../util/General";
import { ModalEliminarUsuario } from "../vam/modal/ModalEliminarUsuario";

export const VisorAll = () => {
    const alert = useRef(null);
    const user = useSelector(state => state.user);

    const [usuarios, setUsuarios] = useState({ list: [], loading: false });

    useEffect(() => {
        getUsuariosVamGen();
    }, []);

    const getUsuariosVamGen = () => {
        user.id &&
            axios
                .get(routes.api + "/users-vam-gen")
                .then(resp => setUsuarios({ ...usuarios, list: resp.data }))
                .catch(err => alert.current.handle_error(err));
    };

    const handleActivos = () => {
        const total = usuarios.list.filter(i => i.activo === true);
        return total.length;
    };

    const handleArray = props => {
        const array = props.value.split(",") || [];
        return (
            <div className={"d-flex flex-column"}>
                {array.map((i, idx) => (
                    <small key={idx}> {i}</small>
                ))}
            </div>
        );
    };

    return (
        <>
            <div className="content">
                <Alerts ref={alert} />
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <CardTitle className="text-center" tag="h4">
                                    Usuarios
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Container>
                                    <div className={"d-flex flex-row w-50 justify-content-between mb-1"}>
                                        <h5 className={"text-primary"}>
                                            <b># Total: </b>
                                            {usuarios.list.length}
                                        </h5>
                                        <h5 className={"text-primary"}>
                                            <b># Activos: </b>
                                            {handleActivos()}
                                        </h5>
                                    </div>
                                    <Row>
                                        <Col>
                                            <ReactTable
                                                noDataText={"No hay datos..."}
                                                loadingText={"Cargando..."}
                                                rowsText={"filas"}
                                                ofText={"de"}
                                                previousText={"Anterior"}
                                                nextText={"Siguiente"}
                                                pageText={"Página"}
                                                columns={[
                                                    {
                                                        Header: "N.",
                                                        Cell: row => {
                                                            return <div>{row.index + 1}</div>;
                                                        },
                                                        width: 60,
                                                        hideFilter: true,
                                                        filterable: false,
                                                    },
                                                    {
                                                        Header: "CD Adicional",
                                                        accessor: "id",
                                                        filterable: false,
                                                        width: 100,
                                                    },
                                                    {
                                                        Header: "Correo",
                                                        accessor: "usuario",
                                                        filterable: true,
                                                    },
                                                    {
                                                        Header: "Activo",
                                                        accessor: "activo",
                                                        width: 85,
                                                        filterable: false,
                                                        Cell: row => {
                                                            return row.original.activo === true ? (
                                                                <p>
                                                                    <span className={"badge badge-success"}>SI</span>
                                                                </p>
                                                            ) : (
                                                                <p>
                                                                    <span className={"badge badge-danger"}>NO</span>
                                                                </p>
                                                            );
                                                        },
                                                    },
                                                    {
                                                        Header: "Contratante",
                                                        accessor: "apAsegurado",
                                                        filterable: false,
                                                        Cell: props => <>{handleArray(props)}</>,
                                                    },
                                                    {
                                                        Header: "Asegurado",
                                                        accessor: "nmAsegurado",
                                                        filterable: false,
                                                        Cell: props => <>{handleArray(props)}</>,
                                                    },
                                                    {
                                                        Header: "Boton",
                                                        accessor: "elmAsegurado",
                                                        filterable: false,
                                                        Cell: props => (
                                                            <ModalEliminarUsuario
                                                                id={props.original.id}
                                                                userAccount={props.original.usuario}
                                                                getUsuariosVamGen={getUsuariosVamGen}
                                                            />
                                                        ),
                                                    },
                                                ]}
                                                data={usuarios.list}
                                                loading={usuarios.loading}
                                                pageSize={usuarios.list.length}
                                                showPaginationBottom={false}
                                                filterable
                                                defaultFilterMethod={filterCaseInsensitive}
                                                className="-striped -highlight"
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};
